// Centralized imports for Super Admin wireframe assets so Webpack bundles them correctly.
// Note: Paths with spaces are fine as long as they are in quotes.

// Logos & general images (explicitly used in pages)
import lmLogo from './img/lm_logo.svg';
import dummyAvatar from './img/dummy_avtar.png';
import graphImage from './img/garph.png';

// `lm-logo-white` exists under `icons` in the wireframe folder
import lmLogoWhite from './icons/lm-logo-white.svg';

// Icons (explicitly used in pages)
import profileSettingIcon from './icons/profile-setting-icon.svg';
import signoutIcon from './icons/signout-icon.svg';
import editPenIcon from './icons/edit-pen.svg';
import closePopupIcon from './icons/close_popup.svg';
import seeTransactionsIcon from './icons/see_transactions.svg';
import emailIcon from './icons/email_icon.svg';
import trashGridIcon from './icons/trash-icon-grid.svg';
import downloadIcon from './icons/download_icon.svg';
import downloadFilledIcon from './icons/download-icon.svg';
import reviewIcon from './icons/Review_icon.svg';
import deleteIcon from './img/delete.svg';
import closeMenuIcon from './icons/close_menu_icon.svg';
import badgeCheckIcon from './icons/badge-check.svg';
import loaderGIF from './gif/loader.gif';
import passwordEyeIcon from './img/pass_eye.svg';
import loginErrorIcon from './icons/login-error-icon.svg';
import warningIcon from './icons/warning_icon.svg';
import passSugnTickIcon from './icons/pass-sugn-tick.svg';
import passSugnCrossIcon from './icons/pass-sugn-cross.svg';
import infoTooltipIcon from './icons/Info-tooltip.svg';
import dateIcon from './icons/date-icon.svg';
import lineLoader from './icons/line-loader.svg';
import timeIcon from './icons/time-icon.svg';
import changePasswordIcon from './icons/change-password-icon.svg';
import settingsIcon from './icons/settings.svg';
import generalSettingIcon from './icons/general_setting.svg';

// Helper to import *all* assets from the wireframe folders, keyed by filename.
// Example usage: wireframeIcons['dashboard.svg'], wireframeImages['lm_logo.svg']
/* eslint-disable global-require, import/no-dynamic-require */
const importAll = (r) => {
  const assets = {};
  r.keys().forEach((key) => {
    const cleanedKey = key.replace('./', '');
    assets[cleanedKey] = r(key);
  });
  return assets;
};

const wireframeIcons = importAll(
  require.context('./icons', true, /\.(png|jpe?g|svg|gif)$/),
);

const wireframeImages = importAll(
  require.context('./img', true, /\.(png|jpe?g|svg|gif)$/),
);
/* eslint-enable global-require, import/no-dynamic-require */

export {
  // Named exports used directly in React pages
  lmLogo,
  lmLogoWhite,
  dummyAvatar,
  graphImage,
  profileSettingIcon,
  signoutIcon,
  editPenIcon,
  closePopupIcon,
  seeTransactionsIcon,
  emailIcon,
  trashGridIcon,
  downloadIcon,
  reviewIcon,
  deleteIcon,
  closeMenuIcon,
  badgeCheckIcon,
  // Bulk maps of all assets
  wireframeIcons,
  wireframeImages,
  downloadFilledIcon,
  loaderGIF,
  passwordEyeIcon,
  loginErrorIcon,
  warningIcon,
  passSugnTickIcon,
  passSugnCrossIcon,
  infoTooltipIcon,
  dateIcon,
  lineLoader,
  timeIcon,
  changePasswordIcon,
  settingsIcon,
  generalSettingIcon
};

